export type RowObj = {
  coin: string;
  quantity: number;
  averageCost: number;
  currentPrice: number;
  marketValue: number;
  unrealizedPnl: number;
  pnlPercent: number;
};

const tableDataComplex: RowObj[] = [
  {
    coin: 'BTC',
    quantity: 0.35,
    averageCost: 42000,
    currentPrice: 45200,
    marketValue: 15820,
    unrealizedPnl: 1120,
    pnlPercent: 7.62,
  },
  {
    coin: 'ETH',
    quantity: 4.2,
    averageCost: 2200,
    currentPrice: 2450,
    marketValue: 10290,
    unrealizedPnl: 1050,
    pnlPercent: 11.36,
  },
  {
    coin: 'SOL',
    quantity: 120,
    averageCost: 85,
    currentPrice: 72,
    marketValue: 8640,
    unrealizedPnl: -1560,
    pnlPercent: -15.29,
  },
  {
    coin: 'BNB',
    quantity: 18,
    averageCost: 310,
    currentPrice: 335,
    marketValue: 6030,
    unrealizedPnl: 450,
    pnlPercent: 8.06,
  },
  {
    coin: 'ADA',
    quantity: 3200,
    averageCost: 0.48,
    currentPrice: 0.42,
    marketValue: 1344,
    unrealizedPnl: -192,
    pnlPercent: -12.5,
  },
];
export default tableDataComplex;
